import exExternal from '../../../external';

// ----------------------------------------------------------------------------

function getRow(element: HTMLElement, id: string): Record<string, any> {
    // @ts-expect-error
    return exExternal.jquery(element).treetable('node', id).row;
}

// ----------------------------------------------------------------------------

export { getRow };
